import React from 'react';
import { Form } from '@ant-design/compatible';
import { Button, Tooltip } from 'antd';
import PasswordInput from '../PasswordInput';
import { Redirect, Link } from 'react-router-dom';
import srcFleetclearLogo from '../../assets/images/fleetclear-logo.svg';

import './resetPasswordForm.scss';

export default function () {
    const {
        form, isValidResetPassword, isSucessResetPassword,
    } = this.props;
    
    const { getFieldDecorator, getFieldValue, getFieldError } = form;

    const newPassword = getFieldValue('new_password');
    const newPasswordError = getFieldError('new_password');
    const confirmNewPassword = getFieldValue('new_password_confirm');

    if (isSucessResetPassword && isValidResetPassword) {
        return <Redirect to="/" />;
    } else {
        return (
            <div className="loginform-wrap">
                <div className="loginform-container">
                    <div className="d-flex dir-column align-center text-center">
                        <img 
                            src={srcFleetclearLogo} 
                            className="login__logo-fleet" 
                            alt="Fleetclear" 
                            style={{ width: '80%' }} 
                        />
                        <br />
                        <br />
                    </div>
                    <Form 
                        onSubmit={this.handleSubmit} 
                        layout="vertical" 
                        className="form mt-3"
                    >
                        <Form.Item>
                            {getFieldDecorator('new_password', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please enter new password!',
                                    },
                                    {
                                        min: 8,
                                        message: 'A new password must be at least 8 characters length!\n\r',
                                    },
                                    {
                                        pattern: /\d+/,
                                        message: 'Must contain at least 1 digit\n\r',
                                    },
                                    {
                                        pattern: /[A-Z]+/,
                                        message: 'Must contain at least 1 uppercase character\n\r',
                                    },
                                    {
                                        pattern: /[a-z]+/,
                                        message: 'Must contain at least 1 lowercase character\n\r',
                                    },
                                    {
                                        pattern: /[!#$@%\-_=+<>\'"`£^&¬\.*\(\)\[\]\?:;\/,{}]/,
                                        message: 'Must contain at least 1 special character',
                                    },
                                ],
                            })(
                                <PasswordInput 
                                    placeholder="Enter New Password" 
                                    className="login-password" 
                                />
                            )}
                        </Form.Item>
                        <Form.Item>
                            {getFieldDecorator('new_password_confirm', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please confirm your new password!',
                                    },
                                ],
                            })(
                                <PasswordInput 
                                    placeholder="Confirm New Password" 
                                    className="login-password" 
                                />
                            )}
                        </Form.Item>
                        {confirmNewPassword && newPassword !== confirmNewPassword && (
                            <p style={{ 
                                color: '#ff4d4f', // same as antd validation
                                fontSize: '12px',
                                marginTop: '-16px',
                            }}>
                                Passwords do not match!
                            </p>
                        )}
                        <div className="text-center mt-2">
                            <Button 
                                type="primary" 
                                htmlType='submit'
                                disabled={!newPassword || !confirmNewPassword || (confirmNewPassword && newPassword !== confirmNewPassword) || newPasswordError}
                            >
                                Reset Password
                            </Button>
                        </div>
                        <br />
                        <div>
                            <Link to="/">
                                <span className="link-green btn-empty underlined center-align">
                                    Cancel
                                </span>
                            </Link>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}
